import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import _isNil from 'lodash/isNil';
import { PATTERN_TYPES, PATTERN_CIRCLE } from './Pattern.constants';
import { patternPropsGetter } from './Pattern.utils';
import { ChildrenPropType } from '../../../../services/proptypes';
import Color from '../Color';
import './Pattern.css';
var defaultProps = {
  type: PATTERN_CIRCLE,
  color: 'black',
  backgroundColor: undefined
};
function Pattern(_ref) {
  var type = _ref.type,
    color = _ref.color,
    backgroundColor = _ref.backgroundColor,
    children = _ref.children;
  if (_isNil(children)) {
    return null;
  }
  var propGetter = patternPropsGetter(type);
  var colorExtraProps = propGetter({
    type: type,
    color: color,
    backgroundColor: backgroundColor
  });
  return /*#__PURE__*/React.createElement(Color, _extends({
    color: backgroundColor,
    style: {
      color: color
    }
  }, colorExtraProps), children);
}
Pattern.defaultProps = defaultProps;
export default Pattern;